import React, { FC } from 'react'

import { IconAccelerometerProps } from './IconAccelerometer.types'
import * as Styled from './styles/IconAccelerometer.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAccelerometer: FC<IconAccelerometerProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAccelerometerProps['size'],
  isResponsive = false,
}: IconAccelerometerProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#042a76bf-1cdf-49a3-af02-b190b41503c7__a)' strokeWidth='2'>
          <path d='M42.955 24.075a19 19 0 1 1-19-19h19v19Z' stroke='#0D0D0D' />
          <path d='M23.955 9.225v2.912' stroke='#0D0D0D' strokeLinecap='round' />
          <path d='M34.508 13.61 23.965 24.15' stroke='#E60000' strokeLinecap='round' />
          <path d='M38.87 24.17h-2.912M13.453 13.575l2.06 2.06m-6.411 8.44h2.915' stroke='#0D0D0D' strokeLinecap='round' />
          <path d='M23.955 25.192a1.117 1.117 0 1 0 0-2.234 1.117 1.117 0 0 0 0 2.235Z' stroke='#E60000' strokeLinecap='round' />
        </g>
        <defs>
          <clipPath id='042a76bf-1cdf-49a3-af02-b190b41503c7__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAccelerometer
